import { render } from "./TasksExecute.vue?vue&type=template&id=c977f856"
import script from "./TasksExecute.vue?vue&type=script&lang=js"
export * from "./TasksExecute.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/driver.blackwidow.org.za/releases/80919820/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QForm,QSelect,QBtn,QItemLabel,QInput,QImg,QSpinnerGears,QCardActions,QOptionGroup,QSlider,QList,QItem,QItemSection,QIcon,QSpinnerDots,QSeparator});qInstall(script, 'directives', {Ripple});
